import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class GrossPriceLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.product.validation.gross-price.less-than-zero-error');
    }
}
